module.exports = __webpack_public_path__ + "static/media/gas.7aff9a47.jpg";